export default __webpack_public_path__ + "static/media/MM_WEBSITE.9152d3cb.png";